import { Box, LinearProgress, LinearProgressProps, styled } from '@mui/material';
import { ReactElement } from 'react';

const Wrapper = styled(Box)(() => ({
    flexGrow: 1,
    alignSelf: 'center',
    borderRadius: 2,
}));

export const PoolLinearProgress = (props: LinearProgressProps): ReactElement => (
    <Wrapper>
        <LinearProgress {...props} sx={{ borderRadius: 2 }} />
    </Wrapper>
);
